<template>
  <div id="burberry-auth" />
</template>

<script>
import { mapActions } from 'vuex';
import router from '../../_router';

export default {
  methods: {
    ...mapActions('account', ['burberrylogin']),
  },
  async mounted() {
    const { code, error } = this.$route.query;
    if (code) {
      try {
        await this.burberrylogin({ code });
      } catch (e) {
        router.push({ name: 'LoginPage', params: { ssoError: true } });
      }
    } else {
      alert(`Login failed: ${error}`);
    }
  },
};
</script>

<style></style>
